<template>
  <div class="contactUser">
    <div
      v-for="(user, i) in users"
      :key="i"
      class="logged-user-w avatar-inline"
      @click="handleOnUserClick(user)"
    >
      <div class="logged-user-i">
        <div class="avatar-w">
          <img :src="calcImage(user.image, user.genderId)"
               alt>
          <p>{{ user.name }}</p>
          <div :class="isOnline(user.id) ? 'green' : 'red'"
               class="status-pill"/>
        </div>

        <br>

        <div class="logged-user-toggler-arrow">
          <div class="os-icon os-icon-chevron-down"/>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import buildQuery from 'odata-query'
export default {
	name: 'user-list',
	data () {
		return {
			userChats: null,
			activeMenu: false,
			users: []
		}
	},
	computed: {
		...mapGetters('User', ['user', 'onlineUsers'])
	},
	watch: {
		user (newVal, oldVal) {
			if (newVal && (newVal.image !== oldVal.image)) {
				let index = this.users.findIndex((user) => user.id === newVal.id)
				this.users[index].image = `${uploadPath}${newVal.image}`
			}
		}
	},
	mounted () {
		this.getUsers()
	},
	methods: {
		async getUsers () {
			try {
				let query = buildQuery({
					select: ['id', 'name', 'surname', 'image']
				})
				const { data } = await this.$http.get(`Employees`)
				this.users = data.value
			} catch (err) {
				console.log(err)
			}
		},
		handleOnUserClick (user) {
			if (user.id === this.user.id) {
				this.$router.push({ name: 'app.user.profile' })
				return
			}
			this.$router.push({ name: 'app.user.chat', query: { id: user.id } })
		},
		isOnline (userId) {
			return !!this.onlineUsers.find(user => user.id === userId)
		}
	}

}
</script>
<style scoped>
div#shortcut.active {
  z-index: 100;
  opacity: 1;
  display: block;
  top: 3.2rem;
}

.menu-w.color-scheme-dark .contactUser .logged-user-w .avatar-w .status-pill {
    position: absolute;
    left: 5px;
    bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/web/userContact/index.vue